
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { Container, Card, Form, Button } from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { toast } from "react-hot-toast";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../../../Pages/User/Auth/Signup/phone-input.css';
import Select from 'react-select';
import { useRoles } from '../../../utils/useRoles';
import { useAuth } from '../../../authentication/AuthContext';



export default function EditUser() {
  const navigate = useNavigate();

  const [screenloader, setScreenloader] = useState(true);
  const [userRefId, setUserRefId] = useState("");
  const [email, setEmail] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [country, setCountry] = useState("");
  const [organization, setOrganization] = useState("");
  const [verified, setVerified] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState("");
  // A user is assigned a ROLE; the portal (Users.type) is derived from it on the
  // server, so the form never sends a type of its own — that is what keeps the
  // two from drifting apart.
  const [roleId, setRoleId] = useState(null);
  // The role as loaded. Details save through PUT /admin/users/:id, which keeps
  // the role; a CHANGE goes through PUT /admin/users/:id/role and needs
  // admin.users.update_role — without it the picker is shown read-only.
  const [originalRole, setOriginalRole] = useState({ id: null, name: "", userType: null });
  const [resellerId, setResellerId] = useState("");
  const { can } = useAuth();
  const canChangeRole = can('admin.users.update_role');
  const { roleOptions, loading: rolesLoading } = useRoles();

  const selectedRole = roleOptions.find(opt => opt.value === roleId)
    // Without the dropdown permission there are no options to look the role up
    // in, so fall back to what the user record itself says.
    || (roleId && roleId === originalRole.id ? { value: originalRole.id, label: originalRole.name, userType: originalRole.userType } : null);
  // The reseller code only means anything for a customer-portal role.
  const isCustomerRole = selectedRole?.userType === 'user';

  const Param1 = useParams();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const loc = location.pathname === `/admin/license/user/${Param1}` ? true : false;
  const id = Param1.id;


  const getLicenseDetail = async () => {
    await axios.get(`${process.env.REACT_APP_API_URL}/admin/users/${id}`, {
      headers: {
        'access-token': localStorage.getItem('accessToken'),
      },
    })
      .then(res => {
        setScreenloader(false);
        if (res.data.status) {
          const data = res.data.user
          setEmail(data.email);
          setFname(data.fname);
          setLname(data.lname);
          setCountry(data.country);
          setOrganization(data.organization);
          setUserRefId(data.user_reference_id);
          setVerified(data.verified);
          setPhoneNumber(data.phone_number || "");
          setRoleId(data.role_id ?? null);
          setOriginalRole({ id: data.role_id ?? null, name: data.role_name || "", userType: data.role_user_type || null });
          setResellerId(data.reseller_id || "");
          return;
        }
        else {
          toast.error('No license found');
          console.log(res.data);
          return;
        }
      })
      .catch(er => {
        setScreenloader(false);
        if (er.response.data?.message) {
          toast.error(er.response.data.message)
        } else {
          console.log(er)
          toast.error("Something Went Wrong")
        }
      })
  };
  useEffect(() => {
    getLicenseDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showError = (er) => {
    if (er.response?.data?.message) {
      toast.error(er.response.data.message)
    } else {
      console.log(er)
      toast.error("Something Went Wrong")
    }
  }

  const UpdateLicense = async () => {
    setScreenloader(true);
    const roleChanged = canChangeRole && roleId && roleId !== originalRole.id;
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/admin/users/${id}`, {
        id: id,
        user_reference_id: userRefId,
        email: email,
        fname: fname,
        lname: lname,
        country: country,
        organization: organization,
        verified: verified,
        phone_number: phoneNumber,
        // Echo the role as loaded; this route never changes it.
        role_id: originalRole.id,
        reseller_id: resellerId !== "" ? parseInt(resellerId) : null
      }, {
        headers: {
          'access-token': localStorage.getItem('accessToken'),
        },
      });
      if (!res.data.status) {
        setScreenloader(false);
        toast.error(res.data.message || 'Could not update User!');
        return;
      }

      if (roleChanged) {
        const roleRes = await axios.put(`${process.env.REACT_APP_API_URL}/admin/users/${id}/role`,
          { role_id: roleId },
          { headers: { 'access-token': localStorage.getItem('accessToken') } });
        if (!roleRes.data.status) {
          // Details are already saved — say exactly which half failed.
          setScreenloader(false);
          toast.error(`Details saved, but the role was not changed: ${roleRes.data.message}`);
          return;
        }
      }

      setScreenloader(false);
      toast.success(roleChanged ? "User and role updated successfully!" : "User updated successfully!");
      setTimeout(() => {
        navigate("/admin/users");
      }, 500)
    } catch (er) {
      setScreenloader(false);
      showError(er);
    }
  }


  const Actions = () => {
    return (
      <>
        <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
          <Button className="btn admin-btn" onClick={UpdateLicense} variant="success">Update</Button>
          <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none' }} onClick={() => { navigate(-1) }} variant="danger">Back</Button>
        </div>
      </>
    )
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      borderColor: '#dee2e6',
      boxShadow: 'none',
      '&:hover': { borderColor: '#dee2e6' }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#5f75a5" : "white",
      color: state.isFocused ? "white" : "#333",
      cursor: 'pointer',
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };
  return (
    <div>
      <style>
        {`
                   .form-select option:hover {
            background-color: #5f75a5ff !important;
        `}
      </style>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <h2>Edit User</h2>
            <Container fluid className='behind'>
              <Card className='mt-4'>
                <Card.Body>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>User Reference Id</Card.Subtitle>
                      <Form.Control
                        className="fontBold"
                        required
                        placeholder="Enter Reference Id"
                        title="Ref ID"
                        type="number"
                        name="Ref ID"
                        value={userRefId}
                        onChange={(event) => {
                          setUserRefId(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Email</Card.Subtitle>
                      <Form.Control
                        className="fontBold"
                        required
                        placeholder="Enter Email"
                        title="PID"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(event) => {
                          setEmail(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>First Name</Card.Subtitle>
                      <Form.Control
                        type='text'
                        required
                        value={fname}
                        onChange={(event) => {
                          setFname(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>last Name</Card.Subtitle>
                      <Form.Control
                        type='text'
                        required
                        value={lname}
                        onChange={(event) => {
                          setLname(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Country</Card.Subtitle>
                      <Form.Control
                        type='text'
                        required
                        value={country}
                        onChange={(event) => {
                          setCountry(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Organization</Card.Subtitle>
                      <Form.Control
                        type='text'
                        required
                        value={organization}
                        onChange={(event) => {
                          setOrganization(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Email Verified</Card.Subtitle>
                      <Form.Control
                        type='number'
                        required
                        value={verified}
                        onChange={(event) => {
                          setVerified(event.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Phone Number</Card.Subtitle>
                      <div className="PhoneInput-wrapper">
                        <PhoneInput
                          international
                          placeholder="Enter phone number"
                          value={phoneNumber}
                          onChange={setPhoneNumber}
                          id="phoneNumber"
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Role</Card.Subtitle>
                      <Select
                        styles={customStyles}
                        options={roleOptions}
                        isLoading={rolesLoading}
                        isDisabled={!canChangeRole}
                        placeholder={rolesLoading ? "Loading roles…" : "Select a role"}
                        value={selectedRole}
                        onChange={(e) => {
                          setRoleId(e.value);
                          if (e.userType !== 'user') setResellerId("");
                        }}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                      />
                      {!canChangeRole && (
                        <small className="text-muted">You don't have permission to change roles.</small>
                      )}
                    </div>
                  </div>
                  {isCustomerRole && (
                    <div className='row my-4'>
                      <div className='col-lg-4 col-md-4 col-6'>
                        <Card.Subtitle className='mb-2 text-muted'>Reseller ID <span className="text-muted" style={{ fontWeight: 'normal', fontSize: '12px' }}>(optional — links user to a reseller)</span></Card.Subtitle>
                        <Form.Control
                          type='numeric'
                          placeholder="Enter Reseller Profile ID"
                          value={resellerId}
                          onChange={(e) => setResellerId(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                  {Actions()}
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}